import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'amfe-flexible'
import Http from './service/request.js'
import { GetParam } from "@/utils/getParam.js";
import {getLogin } from '@/api/info'
Vue.prototype.$Http = Http // 把Http挂载到vue 实例上  全局都可以用

Vue.config.productionTip = false
Vue.use(Vant)
Vue.config.ignoredElements = ["wx-open-subscribe",'wx-open-launch-weapp'];

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title= '全球灯云'
  }
  // console.log('to.meta.requireLogin',to.meta.requireLogin)
  // 在main.js里判断是否是ios和vuex保存的这个url是否为空，为空则存入当前url：
  var u = navigator.userAgent;
  var isIos = u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1
  // console.log('ios main.js',isIos)
  if (isIos && store.state.wxSignUrl == ''){
    store.commit("setWechatSignUrl", location.href.split("#")[0]);
  } else {
    // console.log('安卓')
  }
  // console.log(window.g)
  // 微信授权登录

  // var tokens = 'Bearer 975|3hSO4ngJRj5K5eFFMEiK62WdOOIQo8wt493LcabJ'
  // store.commit("setToken", tokens); // 保存token



  // var token = store.state.token;
  // // let redirect_uri = encodeURIComponent('http://jpzs-zst.itos.cn/')
  // let appid = 'wxe86e357621c76520'
  // let baseUrl= ''
  // if (process.env.VUE_APP_MODE === 'development') {
  //   // 开发环境下的执行操作
  //   baseUrl = 'http://localhost.itos.cn'
  //   // console.log('kaifa')
  // } else {
  //   // 生产环境下的执行操作
  //   baseUrl = 'http://jpzs-zst.itos.cn'
  // }
  // let redirect_uri = encodeURIComponent( // 本地 http://localhost.itos.cn/  // 线上 http://jpzs-zst.itos.cn
  //   baseUrl + to.fullPath
  // );
  // // console.log(to.path);
  // if (!token) {
  //   console.log('token',token)
  //   //let oAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WX_APPID}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
  //   let url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid +"&redirect_uri=" + redirect_uri +"&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
  //   console.log("window.location.href", window.location.href);
  //   let code = GetParam(window.location.href.split("#")[0], "code");
  //   // console.log(code)
  //   if (!code) {
  //     window.location.href = url;
  //   } else {
  //     console.log('you code')
  //     code = code // GetParam(window.location.href, "code");
  //     console.log(code)
  //     let data = {
  //       code:code,
  //       source: 'ZHQQ'
  //     };
  //   // 下面是我根据我实际业务场景编写的，主要是根据code获取个人信息保存。授权登录走到这一步基本就做完了
  //     getLogin(data).then(res => {
  //       console.log(res)
  //       if (res.code == 200){
  //         store.commit("setToken", res.data.token); // 保存token
  //        // localStorage.setItem('token',res.data.token)
  //        store.commit('setTabbarShow',true);
  //         console.log('登录成功')
  //         console.log(router.currentRoute.fullPath)
  //         console.log(store.state.currPageUrl)
  //         // var urlPage = store.state.currPageUrl
  //         // if (urlPage!=''){
  //         //   router.push(urlPage);
  //         // } else {
  //         //   next();
  //         // }
  //         next();
  //       } else if (res.code==401){ // // 登录过期
  //         console.log(401)
  //         store.commit("setToken", ''); // 清除key
  //         store.commit('setUserInfo', '')
  //         window.location.href = url // 如果请求失败继续走重定向去获取code这一步
  //       }else {
  //         window.location.href = url // 如果请求失败继续走重定向去获取code这一步
  //       }
  //     })
  // 
  //   }
  // } else {
  //   next();
  // }

  // 检测是否为微信环境
  function isWechat() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) === "micromessenger";
  }

  if (to.meta.requireLogin) { // 判断是否要登录 true 登录
    //  页面需要登录后访问
    // console.log('to.meta.requireLogin',to.meta.requireLogin)
    
    // 判断是否要清空token
    const version = process.env.VERSION // 版本号
    const cache_clear = process.env.VUE_APP_CACHE_CLEAR // 是否需要清除缓存字段
    const localVersion = localStorage.getItem('projectVersion')
    console.log('localVersion',localVersion,version)
    if ((!version || version != localVersion) && cache_clear == 1) { // 当版本不一样和cache_clear为true 要清除
      console.log('清除')
      localStorage.clear()
      store.commit("setToken", ''); // 清除key
      store.commit('setUserInfo', '')
      localStorage.setItem('projectVersion', version)
      console.log('localVersion2',localVersion,version)
    } else {
      console.log('不清除')
    }

    var token = store.state.token;

    // 如果不是微信环境，跳过微信授权登录
    if (!isWechat()) {
      console.log('非微信环境，跳过微信授权登录')
      if (!token) {
        // 为非微信环境设置一个临时token
        // 注意：这是临时方案，生产环境建议实现自己的登录系统
        const tempToken = 'Bearer temp_token_for_web_' + Date.now();
        store.commit("setToken", tempToken);
        store.commit('setTabbarShow', true);
        
        // 设置一个临时用户信息（可选）
        const tempUserInfo = {
          id: 'web_user_' + Date.now(),
          nickname: '网页访客',
          avatar: '',
          isWebUser: true // 标记为网页用户
        };
        store.commit('setUserInfo', tempUserInfo);
        
        console.log('非微信环境登录成功，使用临时token')
      }
      next();
      return;
    }

    // 微信环境的原有逻辑
    let appid = window.g.app_id
    let http = window.location.protocol+'//'
    let urls = window.location.hostname // 获取当前访问（域名）
    let baseUrl = http+urls
    let redirect_uri = encodeURIComponent(baseUrl + to.fullPath);
    
  } else {
    console.log('to.meta.requireLogin',to.meta.requireLogin)
    console.log('不要登录')
    next()
  }



})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
